import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import React from 'react';
import { downloadConfigurationByEventId } from '../../../redux/Configuration/actions'; // Ensure the correct import
import { useDispatch } from 'react-redux';

const DownloadConfigButton = ({ eventId }) => { // Use eventId to match the action
  const dispatch = useDispatch();

  const downloadConf = async () => {
    dispatch(downloadConfigurationByEventId(eventId));
  };

  return (
    <Button type="primary" onClick={downloadConf} icon={<DownloadOutlined />} size="small" />
  );
};

export default DownloadConfigButton;
